import { Fragment } from "react";
import { updateOne } from "../../api/sorteo";
import { Form, Input, message, Button } from "antd";

function DeleteRecord({ record, closeModal, reload }) {
  const onFinish = (values) => {
    sendDataToServer(values);
  };

  const sendDataToServer = async (data) => {
    try {
      const response = await updateOne(data, record._id);
      message.success(response.message);
      reload();
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Nombre"
          name="nombre"
          initialValue={record.nombre}
          rules={[
            {
              required: true,
              message: "El nombre es necesario"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <div className="w-full flex gap-4 justify-end">
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>

          <Button type="default" onClick={() => closeModal()}>
            Cancelar
          </Button>
        </div>
      </Form>
    </Fragment>
  );
}
export default DeleteRecord;
